<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from 'svelte-i18n';
	import { zendureRequest } from 'src/services/zendure_reqs';
	//Stores
	//Design system components
	import { Button, Input, toast, Text } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Helpers
	import { makeNumbersPrimaryAndBold } from 'src/helpers/utilities';
	import { devices_config } from '@devices/index';
	import { real_id } from 'src/helpers/interface_helpers';

	$: settingsStore = getDeviceSettings(device.id);
	export let device;

	let settings = $settingsStore;

	$: min = devices_config?.[device?.type]?.modes?.pv?.max_charge_limits[0] || 0;
	$: max = devices_config?.[device?.type]?.modes?.pv?.max_charge_limits[1] || 100;

	// the value in status is multiplied by 10
	let maxCharge = ((settings?.socSet || 0) / 10) as number;
	let cache: number = maxCharge;

	let loading = false;

	const setmaxCharge = async () => {
		if (cache === maxCharge) return;

		if (maxCharge < min || maxCharge > max) {
			return toast.open({
				type: 'danger',
				title:
					$format('movement_limit_toast', {
						values: { min: min, max: max },
					}) || 'Values must be between min - max!',
			});
		}

		let res;
		loading = true;

		res = await zendureRequest(device.id, { max_charge: maxCharge * 10 });
		if (res?.isok) {
			cache = maxCharge;
		}

		onSettingsResponse(res, device);
		loading = false;
	};
</script>

<Text styleType="controls-small" class="mb-s">
	{@html makeNumbersPrimaryAndBold(
		`${$format('max_charge_description', {
			default: `The device will stop charging the battery on {value} %`,
			values: { value: maxCharge },
		})}`,
	)}
</Text>

<Input
	aria-label={$format('input_set_max_charge', {
		default: 'Input set max charge',
	})}
	size="m"
	bind:value={maxCharge}
	icon="fas fa-battery-bolt"
	type={'number'}
	step={1}
	{min}
	{max}
	info={$format('range_min_max_percent_value', {
		values: { min, max },
		default: 'Range: 0 % - 100 %.',
	})}
	error={maxCharge < min || maxCharge > max
		? $format('movement_limit_toast', {
				values: { min: min, max: max },
			}) || 'Values must be between min - max!'
		: ''}
	on:enter={setmaxCharge}
	id="input-j8sgqie"
/>
<Button
	class="mt-s"
	{loading}
	size="m"
	width="full"
	disabled={maxCharge < min || maxCharge > max}
	on:click={setmaxCharge}>{$format('button_save')}</Button
>
